import { render, staticRenderFns } from "./Otherpage.vue?vue&type=template&id=56d20c7c&scoped=true&"
import script from "./Otherpage.vue?vue&type=script&lang=js&"
export * from "./Otherpage.vue?vue&type=script&lang=js&"
import style0 from "./Otherpage.vue?vue&type=style&index=0&id=56d20c7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d20c7c",
  null
  
)

export default component.exports